import type { HomepagePageData } from 'src/app/pages/homepage/pageContext';
import { useHomepagePageData } from 'src/app/pages/homepage/pageContext';

type UsePageBodyReturn = ModelHookResult<{ experiments: HomepagePageData['experiments'] }, undefined>;

export function usePageBody(): UsePageBodyReturn {
	const {
		data: { experiments },
	} = useHomepagePageData();

	return { data: { experiments } };
}
